"use strict";

exports.__esModule = true;
exports.formatDurationAxisTicks = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formatDurationAxisTicks = exports.formatDurationAxisTicks = function formatDurationAxisTicks(time) {
  var previousDay;
  var previousMonth;
  var previousYear;
  return function (it) {
    var date = new Date(Date.parse(_momentTimezone["default"].utc(it).tz(time.timezone.name).format("YYYY-MM-DDTHH:mm")));
    var currentDay = date.getDate();
    var currentMonth = date.getMonth();
    var currentYear = date.getFullYear();
    var canShowDay = false;
    var canShowMonth = false;
    var canShowYear = false;
    if (currentDay !== previousDay) {
      previousDay = currentDay;
      canShowDay = true;
    }
    if (currentMonth !== previousMonth) {
      previousMonth = currentMonth;
      canShowMonth = true;
    }
    if (currentYear !== previousYear) {
      previousYear = currentYear;
      canShowYear = true;
    }
    _momentTimezone["default"].locale("en");
    if (currentMonth === 0 && currentDay === 1 && canShowYear) {
      return _momentTimezone["default"].utc(it).tz(time.timezone.name).format("YYYY");
    } else if (currentDay === 1 && canShowMonth) {
      return _momentTimezone["default"].utc(it).tz(time.timezone.name).format("MMMM");
    } else if (canShowDay) {
      return _momentTimezone["default"].utc(it).tz(time.timezone.name).format("ddd DD");
    } else {
      return _momentTimezone["default"].utc(it).tz(time.timezone.name).format("HH:mm");
    }
  };
};